module.exports = __webpack_public_path__ + "img/customer-logo.c0763fe9.png";